import React from 'react';
import FirmField from './FirmField';
import useFirmPatch from './useFirmPatch';

export default function FirmAboutWidget({ firm, firmId, onRefresh }) {
    const { local, patch } = useFirmPatch(firm, firmId, onRefresh);

    return (
        <div className="space-y-3">
            {(local.industry || local.organizationType || local.followers > 0 || local.linkedinSyncedAt) && (
                <div className="flex items-center gap-2 flex-wrap">
                    {local.industry && (
                        <span className="text-[10px] font-medium text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded border border-emerald-200">{local.industry}</span>
                    )}
                    {local.organizationType && (
                        <span className="text-[10px] font-medium text-purple-700 bg-purple-50 px-1.5 py-0.5 rounded border border-purple-200">{local.organizationType}</span>
                    )}
                    {local.followers > 0 && (
                        <span className="text-[10px] text-gray-500">{local.followers.toLocaleString()} followers</span>
                    )}
                    {local.linkedinSyncedAt && (
                        <span className="text-[10px] text-gray-400 ml-auto">Synced {new Date(local.linkedinSyncedAt).toLocaleDateString()}</span>
                    )}
                </div>
            )}
            {local.slogan && <p className="text-xs italic text-gray-500">"{local.slogan}"</p>}
            <FirmField
                label="Description"
                value={local.description}
                multiline
                placeholder="Add a description…"
                onSave={(v) => patch({ description: v })}
            />
        </div>
    );
}
